<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
        <div class="row">
            <div class="col-12">
                <img src="assets/layout/images/DOW_&_JV_Logo.png" alt="logo" class="login-img">
            </div>
        </div>
        <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius:53px">
                <div class="text-center mb-5">
                    <!-- <img src="assets/demo/images/login/avatar.png" alt="Image" height="50" class="mb-3"> -->
                    <img src="assets/layout/images/Dow-Waste.png" alt="logo" width="350">
                    <div class="text-900 text-3xl font-medium my-3">Sign in to your account</div>
                    <span>Welcome back! Please enter your details.</span>
                    <!-- <span class="text-600 font-medium">Sign in.</span> -->
                </div>
                <div>
                    <label for="email1" class="block text-900 text-xl font-medium mb-2">Username</label>
                    <input id="email1" type="text" placeholder="Enter your Username" [(ngModel)]="username" pInputText class="w-full md:w-30rem mb-5" style="padding:1rem">

                    <label for="password1" class="block text-900 font-medium text-xl mb-2">Password</label>
                    <p-password id="password1" [(ngModel)]="password" placeholder="Enter your Password" [toggleMask]="true" [feedback]="false" styleClass="mb-5 w-full" inputStyleClass="w-full p-3 md:w-30rem"></p-password>

                    <div class="flex align-items-center justify-content-between mb-5 gap-5">
                        <div class="flex align-items-center">
                            <!-- <p-checkbox id="rememberme1" [binary]="true" styleClass="mr-2"></p-checkbox>
                            <label for="rememberme1">Remember me</label> -->
                        </div>
                        <a class="font-medium no-underline ml-2 text-right cursor-pointer" style="color: var(--primary-color)" (click)="showDialog()">Forgot password?</a>
                    </div>
                    <button pButton pRipple label="Sign In" class="w-full p-3 text-xl" (click)="login()" [disabled]="isLoading"></button>
                </div>
            </div>
            <div class="text-center mt-2" style="font-size: 8px;">
                VERSION 1.0.0
            </div>
        </div>
    </div>
</div>

<p-dialog header="" [modal]="true" [(visible)]="forgetPasswordDialog" [style]="{ width: '30rem' }" [closable]="true" (onHide)="onCancel()">
    <h4 class="text-center">Forgot Password</h4>
    <p class="text-center mb-5">Please enter your details.</p>
    <div class="p-fluid">
        <form [formGroup]="forgetPasswordForm">
            <div class="form-group">
                <div class="flex flex-column gap-2 mb-3">
                    <label for="username" class="font-semibold w-6rem">Username</label>
                    <input pInputText id="username" formControlName="username" class="flex-auto form-control" autocomplete="off" placeholder="Enter your Username"/>
                    <div *ngIf="forgetPasswordForm.get('username').invalid && forgetPasswordForm.get('username').touched">
                        <small class="p-error" *ngIf="forgetPasswordForm.get('username').errors.required">Username is required.</small>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="flex flex-column gap-2 mb-5">
                    <label for="email" class="font-semibold w-6rem">Email</label>
                    <input pInputText id="email" formControlName="email" class="flex-auto form-control" autocomplete="off" placeholder="Enter your email to set a new password"/>
                    <div *ngIf="forgetPasswordForm.get('email').invalid && forgetPasswordForm.get('email').touched">
                        <small class="p-error" *ngIf="forgetPasswordForm.get('email').errors.required">Email is required.</small>
                        <small class="p-error" *ngIf="forgetPasswordForm.get('email').errors.email">Invalid email format.</small>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <button pButton pRipple label="Submit" class="btn btn-success w-full p-3" type="button" (click)="submitForget()" [disabled]="isLoading"></button>
</p-dialog>

<p-toast></p-toast>

<div *ngIf="isLoading" class="spinner-overlay">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
</div>